export default {
    sounds: {
        gong: 'Gong',
        chimes: 'Chimes',
        marimba: 'Marimba',
        drop: 'Drop',
        pulse: 'Pulse',
        beep: 'Beep',
        alarm_1: 'Alarm 1',
        alarm_2: 'Alarm 2',
        gentle: 'Gentle',
        loud: 'Loud',
        test: 'Test',
        search: 'Search sounds…',
    },
    pomodoro: {
        start: 'Start',
        pause: 'Pause',
        resume: 'Resume',
        silence: 'Silence',
        paused: 'Paused',
        ready: 'Ready',
        skipTo: 'Skip — go to: {phase}',
        nextPhase: 'Next: {phase}',
        fullscreen: {
            workDone: 'Pomodoro complete!',
            breakDone: 'Break over!',
            focus: 'Focus',
            rest: 'Rest',
            exit: 'Exit full screen (Esc)',
            autoStartOn: 'Auto-start on — after the signal, starting: {phase}',
            escHint: 'Esc exits full screen',
        },
        dialog: {
            today: 'Today {count} pomodoro · {minutes} min of focus',
            workDone: 'Pomodoro complete',
            breakDone: 'Break over',
            paused: 'Paused',
            ready: 'Ready to start',
            cycle: 'Cycle: {done} / {total}',
            overtime: '+{time} over time · next: {phase}',
            goTo: 'Go to: {phase}',
            resetPhase: 'Reset phase',
            focusMode: 'Focus mode (full screen)',
            task: 'What are you working on',
            taskPlaceholder: 'e.g. report for Friday',
            preset: 'Preset',
            presetTitle: '{work} / {short} / {long} min, long every {every}',
            short: 'Short',
            long: 'Long',
            minutesLabel: '{label} min',
            longEvery: 'Long every',
            autoStart: 'Next phase starts automatically',
            workEndSound: 'End of work',
            breakEndSound: 'End of break',
            restoreDefaults: 'Restore defaults',
            restoreTitle: 'Restore default settings?',
            restore: 'Restore',
            restoreMessage: 'Back to 25 / 5 / 15 min, a long break every 4, no auto-start. The task name and cycle will reset — your stats stay.',
        },
        presets: {
            classic: 'Classic',
            short: 'Short',
            deep: 'Deep',
            sprint: 'Sprint',
        },
        phases: {
            work: 'Work',
            shortBreak: 'Short break',
            longBreak: 'Long break',
        },
        weekdays: {
            sun: 'Su',
            mon: 'Mo',
            tue: 'Tu',
            wed: 'We',
            thu: 'Th',
            fri: 'Fr',
            sat: 'Sa',
        },
    },
    timers: {
        title: 'Timers',
        ringing: 'One is ringing — stop it to silence it. | {n} are ringing — stop them to silence them.',
        counting: 'One is counting down — you can close the window, the time keeps running. | {n} are counting down — you can close the window, the time keeps running.',
        intro: 'Three independent countdowns. They keep running after you close the window.',
        heading: 'TIMER {n}',
        overtime: '+{time} over time',
        status: {
            finished: 'Time’s up',
            running: 'Counting down',
            paused: 'Paused',
        },
        stop: 'Stop',
        reset: 'Reset',
        restart: 'Restart',
        name: 'Name',
        namePlaceholder: 'e.g. pasta',
        quick: 'Quick pick',
        minutes: 'Minutes',
        seconds: 'Seconds',
        sound: 'Sound',
    },
};
